import { Card } from '../ui';
import type { TimelineEvent } from '../../exechome/framework';

type Props = {
  events?: TimelineEvent[];
};

const typeIcons: Record<string, string> = {
  synchronization: '⟳',
  ai_decision: '✦',
  publishing: '📦',
  marketplace_event: '🛒',
  audit_event: '📋',
  business_event: '●',
  release: '🚀',
};

export function ExecutiveTimelineWidget({ events = [] }: Props) {
  return (
    <Card padding="sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Timeline</p>
      <ol className="mt-3 space-y-3">
        {events.map((e) => (
          <li key={e.id} className="flex gap-3 text-sm">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs dark:bg-slate-800" aria-hidden="true">
              {typeIcons[e.type] ?? '●'}
            </span>
            <div>
              <p className="font-medium text-slate-900 dark:text-slate-100">{e.title}</p>
              <p className="text-xs text-slate-500">{e.timestamp}</p>
            </div>
          </li>
        ))}
      </ol>
    </Card>
  );
}
